import { render } from "./PrincipaisSegmentos.vue?vue&type=template&id=6374b61f&scoped=true"
import script from "./PrincipaisSegmentos.vue?vue&type=script&lang=js"
export * from "./PrincipaisSegmentos.vue?vue&type=script&lang=js"

import "./PrincipaisSegmentos.vue?vue&type=style&index=0&id=6374b61f&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6374b61f"]])

export default __exports__